module.exports = __webpack_public_path__ + "img/c4.e34fd3a2.svg";